/**
 * Computes the discount amount from a promo rule against the current booking amounts.
 * @param {Object} promo - Promo object with value, discount_type, apply_to_add_ons
 * @param {number} baseAmount - Guest subtotal (excluding fees and add-ons)
 * @param {number} addOnsTotal - Add-ons subtotal
 */
export const computeDiscountAmount = (promo, baseAmount = 0, addOnsTotal = 0) => {
  if (promo.value == null || !promo.discount_type) return promo.discountAmount ?? 0
  const applicableBase = baseAmount + (promo.apply_to_add_ons ? addOnsTotal : 0)
  if (promo.discount_type === "percentage") {
    return Math.max(0, (applicableBase * promo.value) / 100)
  }
  return Math.max(0, Math.min(promo.value, applicableBase))
}
